import React from 'react';

/* Selo do clã usado em TODO o jogo: medalha + nome completo do clã (nunca só a TAG). */
const TAM = {
  xs: { m: 'h-4 w-4', t: 'text-[9px]', p: 'gap-1 px-1.5 py-[1px]' },
  sm: { m: 'h-5 w-5', t: 'text-[10px]', p: 'gap-1 px-1.5 py-[1px]' },
  md: { m: 'h-7 w-7', t: 'text-[11px]', p: 'gap-1.5 px-2 py-0.5' },
  lg: { m: 'h-9 w-9', t: 'text-xs', p: 'gap-2 px-2.5 py-1' },
};

export const GbClanBadge = ({ clan, size = 'sm', onClick, testid, className = '' }) => {
  const nome = clan?.name || clan?.clan_name || '';
  const medal = clan?.medal_img || '';
  const hex = clan?.hex || '#c084fc';
  if (!nome && !medal) return null;
  const s = TAM[size] || TAM.sm;
  const Tag = onClick ? 'button' : 'span';
  return (
    <Tag onClick={onClick} data-testid={testid} title={nome}
      className={`flex max-w-full flex-none items-center rounded-full border ${s.p} ${className}`}
      style={{ borderColor: `${hex}99`, background: `${hex}1f` }}>
      {medal && (
        <img src={medal} alt="" className={`${s.m} flex-none object-contain drop-shadow-[0_0_5px_rgba(255,190,60,.55)]`} />
      )}
      {nome && (
        <span className={`truncate font-black ${s.t}`} style={{ color: hex }}>{nome}</span>
      )}
    </Tag>
  );
};
